export class IdentificativoRichiestaDTO {
	id: string;
	codice: string;
}